import React from "react";

const GreatBritain = () => {
  return (
    <svg
      fill="none"
      height="15"
      viewBox="0 0 20 15"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        height="15"
        id="mask0_305_22367"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "alpha" }}
        width="20"
        x="0"
        y="0"
      >
        <rect fill="white" height="15" width="20" />
      </mask>
      <g mask="url(#mask0_305_22367)">
        <path
          clipRule="evenodd"
          d="M0 0V15H20V0H0Z"
          fill="#2E42A5"
          fillRule="evenodd"
        />
        <mask
          height="15"
          id="mask1_305_22367"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "alpha" }}
          width="20"
          x="0"
          y="0"
        >
          <path
            clipRule="evenodd"
            d="M0 0V15H20V0H0Z"
            fill="white"
            fillRule="evenodd"
          />
        </mask>
        <g mask="url(#mask1_305_22367)">
          <mask
            height="15"
            id="mask2_305_22367"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "alpha" }}
            width="20"
            x="0"
            y="0"
          >
            <rect fill="white" height="15" width="20" />
          </mask>
          <g mask="url(#mask2_305_22367)">
            <path
              d="M-2.22696 13.9284L2.1741 15.7897L20.0999 2.02366L22.4213 -0.742266L17.715 -1.36436L10.4035 4.56781L4.51853 8.5647L-2.22696 13.9284Z"
              fill="white"
            />
            <path
              d="M-1.62445 15.2325L0.617684 16.3126L21.5877 -0.999216H18.4395L-1.62445 15.2325Z"
              fill="#F50100"
            />
            <path
              d="M22.227 13.9284L17.8259 15.7897L-0.0998402 2.02366L-2.4213 -0.742266L2.285 -1.36436L9.59649 4.56781L15.4815 8.5647L22.227 13.9284Z"
              fill="white"
            />
            <path
              d="M22.0768 14.8643L19.8347 15.9445L10.9054 8.53236L8.25809 7.70422L-2.64468 -0.732773H0.50354L11.4002 7.50397L14.2946 8.49699L22.0768 14.8643Z"
              fill="#F50100"
            />
            <mask fill="white" id="path-10-inside-1_305_22367">
              <path
                clipRule="evenodd"
                d="M12.3611 -1.25H7.63889V5H-1.23279V10H7.63889V16.25H12.3611V10H21.2672V5H12.3611V-1.25Z"
                fillRule="evenodd"
              />
            </mask>
            <path
              clipRule="evenodd"
              d="M12.3611 -1.25H7.63889V5H-1.23279V10H7.63889V16.25H12.3611V10H21.2672V5H12.3611V-1.25Z"
              fill="#F50100"
              fillRule="evenodd"
            />
            <path
              d="M7.63889 -1.25V-2.5H6.38889V-1.25H7.63889ZM12.3611 -1.25H13.6111V-2.5H12.3611V-1.25ZM7.63889 5V6.25H8.88889V5H7.63889ZM-1.23279 5V3.75H-2.48279V5H-1.23279ZM-1.23279 10H-2.48279V11.25H-1.23279V10ZM7.63889 10H8.88889V8.75H7.63889V10ZM7.63889 16.25H6.38889V17.5H7.63889V16.25ZM12.3611 16.25V17.5H13.6111V16.25H12.3611ZM12.3611 10V8.75H11.1111V10H12.3611ZM21.2672 10V11.25H22.5172V10H21.2672ZM21.2672 5H22.5172V3.75H21.2672V5ZM12.3611 5H11.1111V6.25H12.3611V5ZM7.63889 0H12.3611V-2.5H7.63889V0ZM8.88889 5V-1.25H6.38889V5H8.88889ZM-1.23279 6.25H7.63889V3.75H-1.23279V6.25ZM0.0172119 10V5H-2.48279V10H0.0172119ZM7.63889 8.75H-1.23279V11.25H7.63889V8.75ZM8.88889 16.25V10H6.38889V16.25H8.88889ZM12.3611 15H7.63889V17.5H12.3611V15ZM11.1111 10V16.25H13.6111V10H11.1111ZM21.2672 8.75H12.3611V11.25H21.2672V8.75ZM20.0172 5V10H22.5172V5H20.0172ZM12.3611 6.25H21.2672V3.75H12.3611V6.25ZM11.1111 -1.25V5H13.6111V-1.25H11.1111Z"
              fill="white"
              mask="url(#path-10-inside-1_305_22367)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default GreatBritain;
